import { layerValue } from './array-types';

/** Status identities are catalog constants; all distance decisions use the shared frontend reader. */
export function statusResumeProximity(status: Record<string, unknown>): { actor: string; target: string; warning: string } | null {
    const value = (key: string): string => String(layerValue(status[key]) ?? '').toUpperCase();
    const type = value('status_item_id');
    if (type === 'ED30CCB0-1645-B97E-B9A6-867D8D0094BD' && value('status_origin_id')) {
        return { actor: value('status_target_id'), target: value('status_origin_id'), warning: 'You must have the book in your possession or within reach to resume reading.' };
    }
    if (type === '426C7E0B-EF44-498C-10B2-B50A9E28E45C' && value('status_caster_id')) {
        return { actor: value('status_target_id'), target: value('status_caster_id'), warning: 'You must be within reach of your trainer to resume training.' };
    }
    return null;
}
